export default "__VITE_ASSET__c7ce22ef__"